import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ModalController } from '@ionic/angular';

import { AuthService } from '../../../../shared/auth.service';
import { Product } from '../../../../models/produto.model';
import { ProductService } from '../../../../services/product.service';
import { Utils } from '../../../../shared/util';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.page.html',
  styleUrls: ['./product-detail.page.scss'],
})
export class ProductDetailPage implements OnInit {
  @Input() product: Product
  @Input() action: 'new'|'edit'

  fb: FormBuilder = new FormBuilder();
  form: FormGroup;

  constructor(
    private auth: AuthService,
    private modalController: ModalController,
    private productService: ProductService,
    public utils: Utils
  ) { }

  ngOnInit() {
    this.buildForm();
  }

  // Monta o formulário de produto
  buildForm() {
    this.form = this.fb.group({
      productId: new FormControl({ value: this.product.produtoId, disabled: true }),
      categoriaId: [this.product.categoriaId || ''],
      descricao: [this.product.descricao || ''],
      imagem: [this.product.imagem || ''],
      valorVenda: [this.product.valorVenda || ''],
      nome: new FormControl({ value: this.product.nome, disabled: true }),
      produtopulse: [this.product.produtopulse]
    });
    this.product.tokenRestaurante = this.auth.getUserRestaurant().token
  }

  closeModal() {
    this.modalController.dismiss();
  }

  // Deveria salvar as alterações do produto mas o desenvolvimento foi parado por alteração do projeto
  saveProduct() {
    if(this.action == 'new') {
      this.utils.showToast({ message: 'Não tá pronto ainda cabaço' })
    } else {
      const prod = new Product();
      Object.keys(this.product).forEach(key => {
        prod[key] = this.product[key]
      });
      Object.keys(this.form.value).forEach(key => {
        prod[key] = this.form.value[key];
      })
      this.productService.update(prod).subscribe(data => {
        if(!data.errors) {
          this.utils.showToast({ message: 'Produto alterado com sucesso' })
          this.modalController.dismiss()
        } else {
          this.utils.showToast({ message: data.message || 'Erro ao atualizar produto' })
        }
      }, error => {
        this.utils.showToast({ message: 'Erro ao atualizar produto' })
      })
    }
  }

  changeEffect(value: boolean) {
    this.form.value.produtopulse = value ? 1 : 0;
  }
}
